import { useCookie } from 'lib/cookies'

export const UID_COOKIE_NAME = 'rh_uid'

export function useUid() {
  const [cookie] = useCookie(UID_COOKIE_NAME, { path: '/'})
  return cookie
}
